module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content goldBg"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('div', [_vm._m(1), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-lg btn-primary btn-block",
    attrs: {
      "to": "/#donate"
    }
  }, [_vm._v("Donate Now")])], 1), _vm._v(" "), _c('div', [_vm._m(2), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-lg btn-primary btn-block",
    attrs: {
      "to": "/#donate"
    }
  }, [_vm._v("Sign Up Now")])], 1), _vm._v(" "), _c('div', [_vm._m(3), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-lg btn-primary btn-block",
    attrs: {
      "to": "/#events"
    }
  }, [_vm._v("Events")])], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('div', {
    staticClass: "container"
  }, [_c('h2', [_vm._v("Ways You Can Help!")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "module-content"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": require("assets/images/PFK_Icon_Backpack.svg"),
      "width": "100",
      "height": "100"
    }
  })]), _vm._v(" "), _c('h5', [_vm._v("Sponsor one backpack — just $60 each")]), _vm._v(" "), _c('p', [_vm._v("Gift a child with a life-changing backpack, filled with necessary supplies — and change their future.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "module-content"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": require("assets/images/PFK_Icon_DonateHand.svg"),
      "width": "100",
      "height": "100"
    }
  })]), _vm._v(" "), _c('h5', [_vm._v("Make a sustaining donation")]), _vm._v(" "), _c('p', [_vm._v("By becoming a sustaining donor, you help create a foundation of support for Pencils For Kids, Inc.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "module-content"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": require("assets/images/PFK_Icon_BigHandLittleHand.svg"),
      "width": "100",
      "height": "100"
    }
  })]), _vm._v(" "), _c('h5', [_vm._v("Join us at an event")]), _vm._v(" "), _c('p', [_vm._v("You can support Pencils for Kids, Inc. by buying a ticket to an upcoming event. ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-49ed3dfe!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/WaysYouCanHelp.vue
// module id = 316
// module chunks = 1